exports = module.exports = require("../../../node_modules/.pnpm/css-loader@1.0.1_webpack@4.46.0/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* 基本色（#625edbを基調） */\n/* #F0EFFF */\n/* #F3F2FC */\n/* #E6E6F7 */\n/* #625edb with 90% opacity */\n/* #FFFFFF */\n/* 75% */\n/* 25% */\n/* 0% */\n/* 15% black */\n/* 渋めの青紫文字色 */\n/* #625edb */\n/* #504db8 */\n/* #625edb 35% */\n/* #504db8 15% */\n/* opt-in theme overrides */\n/* ダークモードのトップバー色 */\n/* #625edb */\n/* #504db8 */\n/* #7366e6 */\n/* #5a40cc */\n/* #6d6dec */\n/* #5545d4 */\n/* #2f1f80 */\n/* 25% */\n/* #5545d4 */\n/* #8b80f0 */\n/* 25% */\n/* #625edb */\n/* #504db8 */\n/* #c6bfff 明るい紫青 */\n.divider_divider_1_Adi {\n    border-right: 1px dashed var(--ui-black-transparent, hsla(0, 0%, 0%, 0.15));\n}\n", ""]);

// exports
exports.locals = {
	"divider": "divider_divider_1_Adi"
};